import { useEffect, useState } from 'react'

function useMediaQuery(query: string): boolean {
  const getMatches = (matchQuery: string): boolean => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(matchQuery).matches
    }
    return false
  }

  const [matches, setMatches] = useState<boolean>(getMatches(query))

  function handleChange() {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query)

    handleChange()

    matchMedia.addEventListener('change', handleChange)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return matches
}

export default useMediaQuery
